//Commands

export const TRUC_COMMAND = 'CMD4351234482'
